define('modules/editor/views/element_popup_info',['require','exports','module','base/layout','lodash','i18n','lib/util','../models/editorstate','ldsh!../templates/elements_popup_info'],function(require, exports, module) {
  'use strict';

  var Layout = require('base/layout'),
    _ = require('lodash'),
    i18n = require('i18n'),
    util = require('lib/util'),
    EditorState = require('../models/editorstate');

  module.exports = Layout.extend({
    template: require('ldsh!../templates/elements_popup_info'),

    initialize: function() {
      this.stepNumber = EditorState.getCurrentStepNumber();
    },

    events: {
      "click .js-help": "triggerTooltip",
      "click .js-copyToClipboard": "onCopyToClipboard"
    },

    triggerTooltip: function() {
      this.clearClipboardFeedback();
      this.$(".js-tooltip").toggleClass("in");
    },

    clearClipboardFeedback: function () {
      this.$el.find('.js-copyToClipboard').each(function () {
        var $this = $(this);
        $this.removeClass('copied').html($this.data('copy-text'));
      });
    },

    onCopyToClipboard: function (e) {
      var $currentTarget = $(e.currentTarget),
        textToCopy = _.unescape($currentTarget.next('code').html()),
        self = this;

      util.copyToClipboard(textToCopy, function () {
        self.clearClipboardFeedback();
        $currentTarget.addClass('copied').html($currentTarget.data('copied-text'));
      });
    },

    helpers: function() {
      return {
        stepNumber: this.stepNumber,
        openPopupLabel: i18n.t('editor.popup.openPopup'),
        copyText: i18n.t('editor.popup.copy'),
        copiedText: i18n.t('editor.popup.copied')
      };
    },

    onRender: function(){
      this.$el.i18n();
    }
  });
});

